import {
  EoFormControlConfig,
  IEoFormControlConfig,
} from '../eo-form/eo-form.config';

export interface IEoFileUploadConfig extends IEoFormControlConfig {
  chooseLabel?: string;
  chooseIcon?: string;
  chooseStyleClass?: string;
  cancelLabel?: string;
  cancelIcon?: string;
  cancelStyleClass?: string;
  removeStyleClass?: string;
  accept?: string;
  maxFileSize?: number;
  fileLimit?: number;
  invalidFileSizeMessageSummary?: string;
  invalidFileSizeMessageDetail?: string;
  invalidFileTypeMessageSummary?: string;
  invalidFileTypeMessageDetail?: string;
  invalidFileLimitMessageSummary?: string;
  invalidFileLimitMessageDetail?: string;
  multiple?: boolean;
  uploadedFiles?: any[];
  prototypeUrl?: string;
}

export class EoFileUploadConfig
  extends EoFormControlConfig
  implements IEoFileUploadConfig
{
  override type?: 'fileUpload' | any;
  chooseLabel?: string;
  chooseIcon?: string;
  chooseStyleClass?: string;
  removeStyleClass?: string;
  cancelLabel?: string;
  cancelIcon?: string;
  cancelStyleClass?: string;
  accept?: string;
  maxFileSize?: number;
  fileLimit?: number;
  invalidFileSizeMessageSummary?: string;
  invalidFileSizeMessageDetail?: string;
  invalidFileTypeMessageSummary?: string;
  invalidFileTypeMessageDetail?: string;
  invalidFileLimitMessageSummary?: string;
  invalidFileLimitMessageDetail?: string;
  multiple?: boolean;
  uploadedFiles?: any[];
  prototypeUrl?: string;

  constructor();
  constructor(obj: IEoFileUploadConfig);
  constructor(obj?: IEoFileUploadConfig) {
    super(obj as IEoFormControlConfig);

    this.type = 'fileUpload';
    this.chooseLabel = obj?.chooseLabel ?? 'Επιλογή';
    this.chooseIcon = obj?.chooseIcon;
    this.chooseStyleClass = obj?.chooseStyleClass;
    this.cancelLabel = obj?.cancelLabel ?? 'Αφαίρεση';
    this.cancelIcon = obj?.cancelIcon ?? 'pi pi-times';
    this.cancelStyleClass =
      obj?.cancelStyleClass ?? 'p-button-outlined p-button-danger';
    this.accept =
      obj?.accept ?? '.pdf, .jpeg, .pjpeg, .jpg, .gif, .x-png, .png';
    this.maxFileSize = obj?.maxFileSize;
    this.fileLimit = obj?.fileLimit;
    this.invalidFileSizeMessageSummary = obj?.invalidFileSizeMessageSummary;
    this.invalidFileSizeMessageDetail = obj?.invalidFileSizeMessageDetail;
    this.invalidFileTypeMessageSummary = obj?.invalidFileTypeMessageSummary;
    this.invalidFileTypeMessageDetail = obj?.invalidFileTypeMessageDetail;
    this.invalidFileLimitMessageSummary =
      obj?.invalidFileLimitMessageSummary ??
      'Έχετε υπερβεί τον μέγιστο αριθμό αρχείων.';
    this.invalidFileLimitMessageDetail =
      obj?.invalidFileLimitMessageDetail ?? '';
    this.multiple = obj?.multiple ?? false;
    this.uploadedFiles = obj?.uploadedFiles ?? [];
    this.prototypeUrl = obj?.prototypeUrl;
    this.removeStyleClass = obj?.removeStyleClass ?? 'p-button-outlined p-button-danger';
  }
}
